import type { IntakeFormData, OwnershipAssignment } from "../types";

/** Required Documents hidden when 20+ enrolled AND replacing medical. */
export function isRequiredDocsVisible(totalEnrolledEmployees: number | null, replacingMedical: "Yes" | "No" | null): boolean {
  return !(totalEnrolledEmployees !== null && totalEnrolledEmployees >= 20 && replacingMedical === "Yes");
}

// Maps each verification-document choice (docVerificationType value) to the upload
// slot it reveals. Shared so the Documents step and the store cleanup agree.
export const DOC_VERIFICATION_SLOT: Record<string, "wageTax" | "payroll" | "newBusinessDocs"> = {
  "State Wage and Tax": "wageTax",
  "Payroll Records": "payroll",
  "Business in operation less than 90 days": "newBusinessDocs"
};

// Take only the fields they read (via Pick) so they work from both the full-data
// registry and the hook's individual field selectors.

/** Data-shaped Required-Documents visibility (wraps the two fields it reads). */
export const isRequiredDocsVisibleFor = (d: Pick<IntakeFormData, "totalEnrolledEmployees" | "replacingMedical">): boolean =>
  isRequiredDocsVisible(d.totalEnrolledEmployees, d.replacingMedical);

/** Prior Carrier Bill upload is shown while replacing existing medical coverage. */
export const isPriorBillVisible = (d: Pick<IntakeFormData, "replacingMedical">): boolean => d.replacingMedical === "Yes";

/** Binder-check upload is shown when paying by check. */
export const isBinderCheckVisible = (d: Pick<IntakeFormData, "paymentMethod">): boolean => d.paymentMethod === "Check";

/** ACH bank details are shown when paying by ACH. */
export const isAchDetailsVisible = (d: Pick<IntakeFormData, "paymentMethod">): boolean => d.paymentMethod === "ACH";

/**
 * Owner Eligibility visible when ANY ownership assignment is enrolling but NOT
 * receiving W-2 wages. Ownership %, W-2, and enrolling now live on the
 * per-(owner, entity) assignment — an owner with no assignments (roster-only)
 * cannot trip this rule.
 */
export function isOwnerEligibilityVisible(assignments: OwnershipAssignment[]): boolean {
  return assignments.some(a => a.enrollingInBenefits === true && a.receivingW2Wages === false);
}
